import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { HolidayService } from '../../../services/holidayservices/holiday.service';
import { Router, RouterModule } from '@angular/router';
import Swal from 'sweetalert2';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-holiday-form',
  templateUrl: './holiday-form.component.html',
  styleUrls: ['./holiday-form.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule,]
})
export class HolidayFormComponent implements OnInit {

  typeArr: any = [];
  public showSpinner = true;
  public holidays: any[] = [];
  user: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  @Output() holidaySaved = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  constructor(public Holiday: HolidayService, public router: Router,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type != "Admin") {
      this.router.navigate(['/dashboard-1']);
    }

  }

  ngOnInit(): void {
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
  onSubmit(f: NgForm) {
    if (!f.value.name || !f.value.startDate) {
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
        title: "Please fill all required fields",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }
    this.addMultipleHolidays(f.value.name, f.value.startDate, f.value.endDate);
  }

  async addMultipleHolidays(name: string, startDate: string, endDate: string) {
    this.showSpinner = true;

    const start = new Date(startDate);
    const end = endDate ? new Date(endDate) : new Date(startDate);

    // Ensure start date is before or equal to end date
    if (start > end) {
      this.showSpinner = false;
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
        title: "Start date must be before or equal to End date",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    const dates: string[] = [];
    const currentDate = new Date(start);
    while (currentDate <= end) {
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
      const day = currentDate.getDate().toString().padStart(2, '0');
      const year = currentDate.getFullYear();
      dates.push(`${year}/${month}/${day}`);
      currentDate.setDate(currentDate.getDate() + 1);
    }

    let allSuccess = true;
    let errorMessage = "";

    for (const dt of dates) {
      try {
        const value = await this.Holiday.addHolidays(name, dt);
        if (value.success !== true) {
          allSuccess = false;
          errorMessage = value.message;
          // If one fails, we probably should break or continue?
          // The backend might complain about duplicates. We'll continue trying to add the rest.
        }
      } catch (error: any) {
        allSuccess = false;
        errorMessage = "Error adding holiday";
      }
    }

    this.showSpinner = false;

    if (allSuccess) {
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
        title: dates.length > 1 ? 'Holidays Added Successfully' : 'Holiday Added Successfully',
        showConfirmButton: false,
        timer: 1500,
      });
      this.holidaySaved.emit();
    } else {
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
        title: errorMessage || 'Failed to add some or all holidays',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  }

}
